// extracted by mini-css-extract-plugin
export default {"form":"PNLx_ZxBKVASMLAAXG1g","label":"EyW0j8gLHcEH0YtfGwg7","textarea":"ROM5o9OryhWaE90wiQAw","error":"_oO1G4MXU8UyFVCetd2y","actions":"He9_dCdAy3byVtjNueWn"};